/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App
 */

import { createApp } from "vue";
import App from "./App.vue";
import { registerPlugins } from "@/plugins";
import { initKeycloak, useAuthStore } from "@/plugins/auth";

// Styles
import "leaflet/dist/leaflet.css";
import "@/assets/css/main.css";

const app = createApp(App);

registerPlugins(app);

// Initialize Keycloak before mounting the app
initKeycloak()
  .then((authenticated) => {
    const authStore = useAuthStore();
    authStore.initializeAuth(authenticated);
    app.mount("#app");
  })
  .catch((error) => {
    console.error("Failed to initialize application:", error);
    app.mount("#app");
  });
